import { render, staticRenderFns } from "./BalanceHistoryTable.vue?vue&type=template&id=2a198c84&scoped=true"
import script from "./BalanceHistoryTable.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./BalanceHistoryTable.vue?vue&type=style&index=0&id=2a198c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a198c84",
  null
  
)

export default component.exports